import { Status } from 'app/shared/model/enumerations/status.model';

export interface IMetScholarship {
  id?: number;
  code?: string;
  name?: string;
  status?: Status;
  nameAr?: string;
  nameEn?: string;
}

export const defaultValue: Readonly<IMetScholarship> = {};
